import { render, staticRenderFns } from "./voice-popup.vue?vue&type=template&id=1419f1eb&shadow"
import script from "./voice-popup.vue?vue&type=script&lang=js&shadow"
export * from "./voice-popup.vue?vue&type=script&lang=js&shadow"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports